import * as styles from "./ComboboxGroupLabel.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";

import type { ComboboxGroupLabelProps } from "./Combobox.types";

export function ComboboxGroupLabel({
  className,
  ...props
}: ComboboxGroupLabelProps): JSX.Element {
  return (
    <BaseCombobox.GroupLabel
      data-slot="combobox-group-label"
      className={clsx(styles.groupLabel, className)}
      {...props}
    />
  );
}
